import type { SolarComputeDataDto } from "~/api/dto/solar-proposal-compute.dto"

export const formatNumber = (
  value: number,
  maximumFractionDigits: number,
): string => Intl.NumberFormat(`en-US`, { maximumFractionDigits }).format(value)

/** A how-it-works step's number: index `0` reads as "01". */
export const formatStep = (index: number): string =>
  String(index + 1).padStart(2, `0`)

/** The package's GPU line, e.g. "Blackwell · 96 GB · 2 GPUs"; null without package data. */
export const formatComputeSpecs = (
  computerData: SolarComputeDataDto | null,
): string | null =>
  computerData
    ? [
        computerData.gpuArchitecture,
        `${formatNumber(computerData.gpuMemoryGb, 0)} GB`,
        computerData.gpusPerNode > 1
          ? `${formatNumber(computerData.gpusPerNode, 0)} GPUs`
          : null,
      ]
        .filter(Boolean)
        .join(` · `)
    : null
